import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  FileInfo,
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1Document,
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesDocument,
  FileInfoInput
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { message } from 'antd';
import { VerificationStatusReportDocumentPicker } from './verification-status-report-document-picker';

interface VerificationStatusReportDocumentPickerContainerProps {
  onMergePdfComplete: () => Promise<void>;
  verificationFileNames: Map<string, string>;
  verificationFileName: string;
  caseId: string;
  onCancel: () => void;
}

export const VerificationStatusReportDocumentPickerContainer: React.FC<VerificationStatusReportDocumentPickerContainerProps> = (props) => {
  const [isProcessingMergingPdfs, setIsProcessingMergingPdfs] = useState(false);
  const [getFilesData, { data: fileData }] = useLazyQuery(CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1Document, {
    fetchPolicy: 'network-only'
  });

  const [mergeAndUploadPdfFiles] = useMutation(CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesDocument);

  const fetchFilesData = () => {
    getFilesData({
      variables: {
        sendReportCaseV1Id: props.caseId,
        fileName: props.verificationFileNames.get('verificationComponentPacket') || 'verification-component-packet.pdf'
      }
    });
  };

  useEffect(() => {
    fetchFilesData();
  }, []);

  const getFileInfo = (file: any): FileInfo | null => (file?.url ? { name: file.name, url: file.url } : null);

  const validUrls: FileInfo[] = [];

  if (fileData) {
    const credentialFile = fileData.sendReportCaseV1?.caseDetails?.application?.credential?.fileByFileName;
    const sendReportFiles = fileData.sendReportCaseV1?.files ?? [];

    const coverLetter = sendReportFiles.map(getFileInfo).find((file) => props.verificationFileNames.get('coverLetter') === file?.name.split('/').pop());
    if (coverLetter) {
      validUrls.push(coverLetter);
    }

    // Find 'verificationComponentPacket'
    if (credentialFile && props.verificationFileNames.get('verificationComponentPacket') === credentialFile.name.split('/').pop()) {
      const verificationComponentPacket = getFileInfo(credentialFile);
      if (verificationComponentPacket) {
        validUrls.push(verificationComponentPacket);
      }
    }
  }

  // const blobUrls: FileInfo[] = [
  //   {
  //     name: '',
  //     url: ''
  //   },
  //   { name: '', url: '' },
  //   { name: '', url: '' }
  // ];

  // //Assign cover letter if available
  // const coverLetter = fileData?.sendReportCaseV1?.files?.find(
  //   (file) => file?.name?.split('/').pop() === props.verificationFileNames.get('coverLetter')
  // );
  // if (coverLetter) {
  //   blobUrls[0] = {
  //     url: coverLetter.url ?? '',
  //     name: coverLetter.name ?? 'cover-letter.pdf',
  //   };
  // }

  // // Assign Verification Packet URL (if available).
  // const credentialFile = fileData?.sendReportCaseV1?.caseDetails?.application?.credential?.fileByFileName;
  // if (credentialFile) {
  //   blobUrls[1] = {
  //     url: credentialFile.url ?? '',
  //     name: credentialFile.name ?? 'verification-component-packet.pdf',
  //   };
  // }

  console.log('blobUrls: ', validUrls);

  const handleMergePdfs = async (blobPaths: FileInfoInput[]) => {
    setIsProcessingMergingPdfs(true);
    mergeAndUploadPdfFiles({
      variables: {
        input: {
          blobPaths: blobPaths,
          caseId: props.caseId,
          fileName: props.verificationFileName
        }
      }
    }).then(async (res) => {
      if (res.data?.sendReportCaseV1MergePdfFiles?.status.success) {
        await props.onMergePdfComplete();
      } else {
        message.error('Error merging PDFs');
      }
      setIsProcessingMergingPdfs(false);
    });
  };

  const handleCancel = () => {
    props.onCancel();
  };
  return (
    <ComponentQueryLoader
      loading={!fileData}
      hasData={fileData}
      hasDataComponent={
        <VerificationStatusReportDocumentPicker
          onCancel={handleCancel}
          isProcessingMergingPdfs={isProcessingMergingPdfs}
          onMergePdfs={handleMergePdfs}
          blobUrls={validUrls}
          verificationFileNames={props.verificationFileNames}
        />
      }
    />
  );
};
